export default __webpack_public_path__ + "static/media/include_10@2x.5bd47969.jpg";